import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';

import { injectCatchHttpError } from '../../../core/errors/catch-http-error.util';
import type { IProject } from '../../models';
import { ApiProjectsService } from '../../services/api/api-projects.service';
import { loadCurrentProject, loadCurrentProjectFail, loadCurrentProjectSuccess } from './projects.actions';

@Injectable()
export class ProjectsEffects {
  private apiProjects = inject(ApiProjectsService);

  private readonly actions$ = inject<Actions>(Actions);
  private readonly catchHttpError = injectCatchHttpError();

  getCurrentProjects$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCurrentProject),
      switchMap(({ id }) =>
        this.apiProjects.getProjectById(id).pipe(
          map((project: IProject) => loadCurrentProjectSuccess({ project })),
          this.catchHttpError(error => loadCurrentProjectFail({ error })),
        ),
      ),
    ),
  );
}
